import useGlobalStore from "stores/global"
import useT from "utils/useT"

const Appearance = () => {
  const t = useT()
  const setAppearance = useGlobalStore((state) => state.setAppearance)
  return (
    <div className="pe-3 ps-3 pt-3">
      <h3 dir="auto" className="font-700 mb-2 font-25">
        {t.settings.appearance}
      </h3>
      <div className="list-group list-custom-small">
        <a onClick={() => setAppearance("Dark")}>
          <i className="fa fa-moon color-grey"></i>
          <span>{t.settings.dark}</span>
        </a>
        <a onClick={() => setAppearance("Light")}>
          <i className="fa color-yellow-dark fa-sun"></i>
          <span>{t.settings.light}</span>
        </a>
        <a onClick={() => setAppearance("Auto")}>
          <i className="fa color-green-light fa-magic"></i>
          <span>{t.settings.auto}</span>
        </a>
      </div>
      <div className="clear"></div>
    </div>
  )
}

export default Appearance
